import AsyncStorage from "@react-native-async-storage/async-storage";
import { useIsFocused } from "@react-navigation/native";
import React, { useEffect, useState } from "react";
import { Text, View } from "react-native";
import { TouchableOpacity } from "react-native-gesture-handler";
import NumberInput from "../../components/NumberInput";
import activesService from "../../services/activesService";
import balanceService from "../../services/balanceService";
import { formatGPXBalance, maxDecimals } from "../../utils/formatNumber";
import { FormattedMessage, useIntl } from "react-intl";
import HeaderTabs from "../../components/HeaderTabs";
import { If, Then, Else, When } from "react-if";
import { useFocusEffect } from "@react-navigation/native";
import GoBackButton from "../../components/GoBackButton";
import ScreenLoader from "../../components/ScreenLoader";
import { useRoute } from "@react-navigation/native";
import styles from "./styles";

const Purchase = ({ navigation }) => {
  const [seconds, setSeconds] = useState(0);
  const [open, setOpen] = useState(false);
  const [actives, setActives] = useState([]);
  const [items, setItems] = useState([]);
  const [balance, setBalance] = useState("");
  const [viewType, setViewType] = useState("buy");
  const [amount, setAmount] = useState(0);
  const [selectedActive, setSelectedActive] = useState("0");
  const [selectedActiveObj, setSelectedActiveObj] = useState({});
  const [price, setPrice] = useState(0.0);
  const [authToken, setAuthToken] = useState(null);
  const [decimals, setDecimals] = useState(0);
  const [amountToken, setAmountToken] = useState(0);
  const [percent, setPercent] = useState(0);
  const [percentBar, setPercentBar] = useState(0);
  const intl = useIntl();
  const [clientCountry, setClientCountry] = useState("");
  const [loading, setLoading] = useState(false);
  const [disableInputs, setDisableInputs] = useState(false);
  const route = useRoute();
  /*   const { activeId } = route.params || {}; */

  const loadTokenAndRequest = async () => {
    const authTokenStorage = await AsyncStorage.getItem("JWT_TOKEN");
    setAuthToken(authTokenStorage);
  };

  const getClientCountry = async () => {
    const country = await AsyncStorage.getItem("client_country");
    setClientCountry(country || "");
  };

  useFocusEffect(
    React.useCallback(() => {
      setAmount(0);
      setSelectedActive("0");
      setSelectedActiveObj({});
      setPrice(0.0);
      setDecimals(0);
      setAmountToken(0);
      setPercent(0);
      setPercentBar(0);

      return () => {};
    }, [isFocused])
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((seconds) => seconds + 1);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (route?.params?.viewType) {
      setViewType(route.params.viewType);
    }
  }, []);

  const isFocused = useIsFocused();
  useEffect(() => {
    if (isFocused) {
      if (route?.params?.viewType) {
        setViewType(route.params.viewType);
      }
    }
  }, [isFocused]);

  useEffect(() => {
    loadTokenAndRequest();
  }, []);

  useEffect(() => {
    const el = actives.find(({ id }) => id == selectedActive);

    if (el?.id == selectedActive) {
      setSelectedActiveObj(el);
      setLoading(false);
      if (el.single_value) {
        setPrice(parseFloat(el.single_value));
      }
      if (el.name_token) {
        if (["BTC", "ETH", "ADA"].includes(el.name_token)) setDecimals(8);
        if (
          !el.cryptoactive &&
          !["BTC", "ETH", "ADA"].includes(el.name_token)
        ) {
          loadAmountToken();
        } else {
          setAmountToken(0);
        }
      }
    }
    if (viewType === "sell") {
      loadBalance();
    }
  }, [selectedActive]);

  useEffect(() => {
    if (viewType === "sell") {
      // Redefine os estados ao mudar para a visualização de venda
      setSelectedActive("0");
      setSelectedActiveObj({});
      setAmount(0);
      setPrice(0.0);
      setBalance("");
    }
  }, [viewType]);

  //LÓGICA DE RECEBER OS DADOS DE CARDSPACOTESSELOS E TRAVAR OS COMPONETES DE TOKEN E QUANTIDADE
  useEffect(() => {
    if (route?.params) {
      if (route?.params?.selectedAssetId) {
        setLoading(true);
        setDisableInputs(true);
        setSelectedActive(route.params.selectedAssetId);
        setLoading(false);
      }

      if (route?.params?.preSelectedPrice) {
        setPrice(parseFloat(route.params.preSelectedPrice));
      }

      if (route?.params?.preSelectedQuantity) {
        setAmount(parseInt(route.params.preSelectedQuantity));
      }
    } else {
      console.error("Dados não recebidos");
    }
    setLoading(false);
  }, [route?.params]);

  useEffect(() => {
    setLoading(true);
    if (route?.params) {
      if (route?.params?.selectedAssetId) {
        setDisableInputs(true);
        setSelectedActive(route.params.selectedAssetId);
      }

      if (route?.params?.preSelectedPrice) {
        setPrice(parseFloat(route.params.preSelectedPrice));
      }

      if (route?.params?.preSelectedQuantity) {
        setAmount(parseInt(route.params.preSelectedQuantity));
      }
    }
    setLoading(false);
  }, [route?.params]);

  const ActiveSelector = ({
    disabled,
    selectedValue,
    onValueChange,
    options,
  }) => {
    return (
      <select
        value={selectedValue}
        onChange={(e) => onValueChange(e.target.value)}
        disabled={disableInputs}
        className={
          disabled ? styles.activeSelectorDisabled : styles.activeSelector
        }
      >
        <option value="0">
          {intl.formatMessage({ id: "purchase.labelsFiltro.selecioneAtivo" })}
        </option>
        {options.map((el, index) => (
          <option key={index} value={el.id}>
            {el.name_token}
          </option>
        ))}
      </select>
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      await loadTokenAndRequest();
      if (authToken) {
        setLoading(true);
        await getClientCountry();
        if (clientCountry) {
          if (viewType === "buy") {
            loadAllActives();
            loadBalance();
          } else {
            await loadActivesWithBalance();
          }
        }
        setLoading(false);
      }
    };

    fetchData();
  }, [authToken, viewType, clientCountry]);

  /* useEffect(() => {
    if (clientCountry) {
      loadAllActives();
      loadActivesWithBalance();
    }
  }, [clientCountry]);
 */
  useEffect(() => {
    if (actives.length > 0) {
      if (route?.params?.selectedActive) {
        setSelectedActive(route.params.selectedActive);
      }
    }
  }, [actives]);

  const loadAmountToken = async () => {
    if (authToken) {
      activesService.getById(authToken, selectedActive).then((response) => {
        if (response.data?.count) {
          setAmountToken(response.data?.count);
        }
      });
    }
  };

  const loadBalance = async () => {
    if (authToken) {
      setLoading(true);
      try {
        if (viewType === "buy") {
          const { data } = await balanceService.getBalanceOfGpx(authToken);
          if (data?.balance?.length > 0) {
            setBalance(data?.balance[0].available_balance + "");
          }
        } else if (viewType === "sell" && selectedActive) {
          const { data } = await balanceService.getBalanceOfToken(
            authToken,
            selectedActive
          );
          setBalance(data?.saldo + "");
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
  };

  const loadAllActives = async () => {
    setLoading(true);
    try {
      const { data } = await activesService.get(authToken);
      if (data.length > 0) {
        const filteredActives = data[0].filter((active) => {
          const isIRec =
            active.category_name === "I-REC" && clientCountry !== "brasil";
          const isSustentavel =
            active.category_name.includes("Sustentável") &&
            clientCountry !== "brasil";
          const isAdoption = active.adoption === true;
          const isPromocional = active.category_name
            .toLowerCase()
            .includes("promocional");

          // Filtra ativos com "Selo" no nome da categoria e single_value >= 50
          const isSelo = active.category_name.includes("Selo");
          const isSingleValueValid = active.single_value >= 0.5;

          // Aplica o filtro para "Selo" com single_value >= 50
          return (
            !isIRec &&
            !isSustentavel &&
            !isAdoption &&
            !isPromocional &&
            (!isSelo || (isSelo && isSingleValueValid))
          );
        });
        setActives(filteredActives);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const loadActivesWithBalance = async () => {
    setLoading(true);
    try {
      const response = await activesService.getActivesWhereUserHasBalance(
        authToken
      );
      if (response.data.length > 0) {
        const filteredActives = response.data.filter((active) => {
          const isAdoption = active.adoption === true;
          const isIRec =
            active.category_name === "I-REC" && clientCountry !== "brasil";
          const isSelo = active.name_token.includes("Selo");
          return !isAdoption && !isIRec && !isSelo;
        });
        setActives(filteredActives);
      }
    } catch (error) {
      console.error("Error fetching actives:", error);
    } finally {
      setLoading(false);
    }
  };

  const actionEnabled = () => {
    if (!selectedActive /* || !selectedActiveObj?.id */) {
      return "purchase.selecioneAtivoMaiuscula";
    }
    if (amount.length === 0) {
      return "purchase.digiteQuantidade";
    }
    //só vai definir um mínimo para cliente brasil
    /*  if (parseInt(amount) < 11 && clientCountry === "brasil") */ // original
    if (parseInt(amount) * price < 11 && clientCountry === "brasil") {
      return "transfer.minimoDe11";
    }
    if (balance.length === "") {
      return "purchase.carregando";
    }
    if (viewType === "buy") {
      if (
        parseFloat(amount + "") *
          parseFloat(selectedActiveObj.single_value + "") >
        parseFloat(balance + "")
      ) {
        return "purchase.saldoInsuficiente";
      }
      return "purchase.comprarMaiuscula";
    }
    if (viewType === "sell") {
      if (parseFloat(amount + "") > parseFloat(balance + "")) {
        return "purchase.saldoInsuficiente";
      }
      return "purchase.venderMaiuscula";
    }
  };

  const hasBalanceToOperation = () => {
    if (viewType === "sell") {
      if (parseFloat(amount + "") > parseFloat(balance + "")) {
        return false;
      }
      return true;
    } else {
      if (amount > 0 && price > 0 && parseFloat(amount * price) > balance) {
        return false;
      } else {
        return true;
      }
    }
  };

  const setAmountOverride = (amount) => {
    if (selectedActiveObj) {
      if (!selectedActiveObj.cryptoactive) {
        setAmount(parseInt(amount + ""));
      } else {
        setAmount(amount + "");
      }
    } else {
      setAmount(amount + "");
    }
  };

  const calcPercentByAmount = () => {
    let amountNumber = parseFloat(amount + "");
    if (
      viewType &&
      amountNumber &&
      price &&
      balance &&
      !isNaN(amountNumber) &&
      !isNaN(price) &&
      !isNaN(balance)
    ) {
      let percentResult =
        viewType === "buy"
          ? Math.floor(((amountNumber * price) / balance) * 100)
          : Math.floor((amountNumber / balance) * 100);
      setPercent(Math.floor(percentResult, 100));
    }
  };

  const calcAmountByPercent = () => {
    let calc = amount;
    if (selectedActiveObj?.cryptoactive) {
      if (viewType === "buy") {
        // 10 custo tenho 50 -> quero usar 10% saldo -> saldo/custo*percentual
        calc = maxDecimals(Math.ceil(balance / price) * (percent / 100), 8);
      } else {
        calc = maxDecimals(balance * (percent / 100), 8);
      }
    } else {
      if (viewType === "buy") {
        // 10 custo tenho 50 -> quero usar 10% saldo -> saldo/custo*percentual
        calc = Math.floor((balance / price) * (percent / 100));
        if (calc === 0) {
          calc = 1;
        }
      } else {
        calc = Math.floor(Math.floor(balance) * (percent / 100));
      }
      if (calc < 1) {
        calc = 0;
      }
    }
    setAmountOverride(calc + "");
  };

  useEffect(() => {
    if (percent != percentBar) {
      setPercentBar(percent);
    }
  }, [amount]);

  return (
    <>
      <ScreenLoader loading={loading} />

      <HeaderTabs
        title={
          <If condition={viewType === "buy"}>
            <Then>
              <FormattedMessage
                id="purchase.tituloComprar"
                style={{ textTransform: "uppercase" }}
              />
            </Then>
            <Else>
              <FormattedMessage
                id="purchase.tituloVender"
                style={{ textTransform: "uppercase" }}
              />
            </Else>
          </If>
        }
        subtitle={<FormattedMessage id="marketplacecategories.subtitulo" />}
      />

      <View style={styles.container}>
        {/* Card Selecione Ativo */}
        <View style={styles.titleSelectionToken}>
          <ActiveSelector
            disabled={disableInputs}
            selectedValue={selectedActive}
            onValueChange={setSelectedActive}
            options={actives}
          />
        </View>
        <View style={styles.contentCard}>
          <If condition={selectedActive && selectedActive !== "0"}>
            <Then>
              {/* Quantidade disponível */}
              <When
                condition={
                  selectedActiveObj?.cryptoactive && parseInt(amountToken) > 0
                }
              >
                <View style={styles.descriptionElements}>
                  <Text style={styles.titleActives}>
                    <FormattedMessage id="purchase.quantidadeDisponivel" />
                  </Text>
                  <Text style={styles.txtPlataforma}>
                    <FormattedMessage id="purchase.plataforma" />
                  </Text>
                  {"\n"}
                  <Text style={styles.subtitleActives}>
                    {amountToken}{" "}
                    {selectedActiveObj && selectedActiveObj.name_token}
                  </Text>
                </View>
              </When>

              {/* Preço */}
              <View style={styles.descriptionElements}>
                <Text style={styles.titleActives}>
                  <FormattedMessage id="purchase.preco" />
                </Text>
                <Text style={styles.subtitleActives}>
                  <If condition={selectedActiveObj.single_value}>
                    <Then>
                      {formatGPXBalance(selectedActiveObj.single_value)}
                    </Then>
                    <Else>{price}</Else>
                  </If>
                  <FormattedMessage id="purchase.gpx" />
                </Text>
              </View>

              {/* Meu saldo */}
              <View style={styles.descriptionElements}>
                <Text style={styles.titleActives}>
                  {""}
                  <FormattedMessage id="purchase.meuSaldo" />
                </Text>
                <Text
                  style={{
                    ...styles.subtitleActives,
                    color: !hasBalanceToOperation() ? "#d63b20" : "#000",
                  }}
                >
                  <If condition={viewType === "buy"}>
                    <Then>
                      <Text> {formatGPXBalance(balance)} </Text>
                      <FormattedMessage id="marketplace.gpxBrl" />
                    </Then>
                    <Else>
                      <If condition={selectedActiveObj?.cryptoactive}>
                        <Then>
                          <Text>{maxDecimals(balance, 8)}</Text>
                        </Then>
                        <Else>
                          <Text>{balance}</Text>
                        </Else>
                      </If>
                      <Text>{selectedActiveObj.name_token}</Text>
                    </Else>
                  </If>
                </Text>
              </View>
              <View style={styles.cardFooter}>
                {/* Seleção de Quantidade */}
                <If condition={disableInputs}>
                  <Then>
                    <Text style={styles.titleActives}>
                      <FormattedMessage id="purchase.quantidadeSelos" />
                    </Text>
                    <Text
                      style={[
                        styles.txtAmount,
                        styles.subtitleActives,
                        styles.quantidadeSelos,
                      ]}
                    >
                      {amount}
                    </Text>
                  </Then>
                  <Else>
                    <NumberInput
                      disabled={disableInputs}
                      minValue={0}
                      value={amount}
                      maxDecimalsParam={decimals}
                      onChange={(value) => setAmount(value)}
                      onBlur={() => {
                        calcPercentByAmount();
                      }}
                    />
                  </Else>
                </If>

                {/* Comprar */}
                <View>
                  <Text style={{ color: "#656565", paddingTop: 5 }}>
                    <When condition={amount > 0 && price > 0}>
                      {formatGPXBalance(amount * price)}{" "}
                    </When>
                    <FormattedMessage id="purchase.gpxBrl" />
                  </Text>
                </View>

                <TouchableOpacity
                  disabled={amount <= 0}
                  style={styles.action_buttons_container}
                  onPress={() => {
                    if (
                      actionEnabled() === "purchase.comprarMaiuscula" ||
                      actionEnabled() === "purchase.venderMaiuscula"
                    ) {
                      navigation.navigate("ConfirmPurchaseOrSell", {
                        qtd: amount,
                        token: selectedActive,
                        viewType: viewType,
                        market:
                          !selectedActiveObj?.cryptoactive && viewType == "sell"
                            ? true
                            : false,
                        price: price,
                      });
                    } else if (
                      actionEnabled() === "purchase.saldoInsuficiente"
                    ) {
                      navigation.navigate("DepositMethod");
                    }
                  }}
                >
                  <Text
                    style={styles.action_button_text}
                    numberOfdescriptionElementss={1}
                  >
                    <FormattedMessage id={actionEnabled()} />
                  </Text>
                </TouchableOpacity>
              </View>
            </Then>
            <Else>
              <Text style={{ textAlign: "center", marginBottom: 20 }}>
                <FormattedMessage id="purchase.mensageAntesContinuar" />
                <If condition={viewType === "buy"}>
                  <Then>
                    <FormattedMessage id="purchase.comprarMaiusculo" />
                  </Then>
                  <Else>
                    <FormattedMessage id="purchase.venderMinusculo" />
                  </Else>
                </If>
              </Text>
            </Else>
          </If>
        </View>

        <GoBackButton />
      </View>
    </>
  );
};

export default Purchase;
